import { isApexAccountOpen } from '../../../Apex/ApexHelpers';

export const getIsAccountSelected = (account: Record<string, any>, selectedAccountId?: string) => {
  if (!selectedAccountId) {
    return false;
  }

  const ApexId = isApexAccountOpen(account.ApexStatus)
    ? account.Item.AccountId
    : account.ManagedAccountId;

  return selectedAccountId === (ApexId || account.Item.AccountId || account.Item.Id);
};
